import React, { Component } from 'react';
import { Table, Row, Button, Spin, DatePicker } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { columnsData } from './data';
import Auth from "../../table/Auth";
import { compute } from "./compute";
import FileSaver from "file-saver";
import TableText from "../../table/TableText";

const { MonthPicker } = DatePicker;
const totalIndex = [];

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            dateData: [],
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            monthDataAll: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        data = await compute(data);
        this.setState({ data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        let data = [];
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getHeadquartersYear?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length >= 0) {
                data = x.data;
            }
            this.setState({ loading: false, }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }


    downloadExcel = () => {
        const tableName = `${moment(this.state.date).format('YYYY-MM')} Monthly completion trend 单体酒店月度完成趋势`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth - 9880 > 650 ? document.body.offsetWidth - 9880 : 650;
        const columns = [{
            title: 'SITE NO.',
            key: 'NO',
            align: "center",
            dataIndex: 'wdm_number',
            fixed: this.state.print ? false : "left",
            width: 80,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {text}
                    </div >
                )
            }
        }, {
            title: 'Hotel Name',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * (8 / 15),
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {record.name.replace(/[^a-zA-Z0-9\s]/g, '')}
                    </div >
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name_cn',
            key: 'name_cn',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * (7 / 15),
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                        {record.name.replace(/[^\u4E00-\u9FA5]/g, "")}
                    </div >
                )
            }
        },
        ...columnsData.map(item => {
            return {
                title: item.title,
                children: item.children.map(x => ({
                    title: x.title,
                    align: "center",
                    width: 150,
                    dataIndex: x.key,
                    key: x.key,
                    sorter: (a, b) => b[x.key] - a[x.key],
                    render: (text = 0, record, index) => {
                        const props = {
                            text,
                            index,
                            type: x.key.includes('occ') ? 'percent' : 'number',
                            name: x.key,
                            onChange: this.onChange,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }))
            }
        })
        ];

        return (
            <Spin spinning={this.state.loading} >
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? 10580 : 'auto' }}>
                        <Row>Monthly completion trend 单体酒店月度完成趋势</Row>
                        {/* <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row> */}
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 10530 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 10530, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.downloadExcel();
                                    });
                                }}
                                loading={this.state.print}
                            >导出Excel</Button>
                        </Row>
                    </Auth>


                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Year/index.js